import React from 'react';
import { FileText, Clock, AlertTriangle, CheckSquare, TrendingUp } from 'lucide-react';
import { isDueSoon } from '../constants/proposalUtils';
import aedCurrencyImg from '../../../assets/images/aedcurrency.jpg';

const StatsGrid = ({ metrics, rfpData }) => {
    // Lead Scoped API mapping
    const isLead = metrics?.scope === 'lead' || metrics?.scope === 'manager' || metrics?.scope === 'admin';

    // Mapping logic based on role
    const activeProposals = isLead
        ? (metrics?.total_rfps ?? 0)
        : (metrics?.total_active ?? rfpData.length);

    const inProgress = isLead
        ? (metrics?.in_progress ?? 0)
        : (metrics?.in_progress ?? rfpData.filter(r => {
            const s = (r.proposal_stage || '').toLowerCase();
            return s.includes('progress') || s.includes('review') || s === 'draft';
        }).length);

    const dueOrExpired = isLead
        ? (metrics?.expired ?? 0)
        : (metrics?.due_this_week ?? rfpData.filter(r => {
            const d = r.proposal_deadline || r.extraction_data?.submission_deadline;
            return isDueSoon(d);
        }).length);

    const submitted = isLead
        ? (metrics?.submitted_to_client ?? 0)
        : (metrics?.submitted ?? rfpData.filter(r => {
            const s = (r.proposal_stage || '').toLowerCase();
            return s.includes('submit');
        }).length);

    const revenue = metrics?.revenue_total ?? 0;
    const winRate = metrics?.win_rate ?? 0;
    const currency = metrics?.currency || 'AED';

    return (
        <section className="dashboard-summary-row">
            <StatCard
                icon={<FileText size={18} />}
                label="Total Proposals"
                value={activeProposals}
                iconClass="stat-icon-blue"
            />
            <StatCard
                icon={<Clock size={18} />}
                label="In Progress"
                value={inProgress}
                iconClass="stat-icon-yellow"
            />
            <StatCard
                icon={<AlertTriangle size={18} />}
                label={isLead ? "Expired" : "Due This Week"}
                value={dueOrExpired}
                iconClass="stat-icon-red"
                valueClass="stat-value-red"
            />
            <StatCard
                icon={<CheckSquare size={18} />}
                label="Submitted"
                value={submitted}
                iconClass="stat-icon-green"
            />
            <StatCard
                icon={<img src={aedCurrencyImg} alt="AED Logo" style={{ width: '22px', height: '22px', objectFit: 'contain', borderRadius: '50%' }} />}
                label="Total Revenue"
                value={<><span className="stat-card-currency">{currency}</span>{revenue.toLocaleString()}</>}
                iconClass="stat-icon-purple"
            />
            <StatCard
                icon={<TrendingUp size={18} />}
                label="Win Rate"
                value={`${winRate}%`}
                iconClass="stat-icon-indigo"
            />
        </section>
    );
};


const StatCard = ({ icon, label, value, iconClass, valueClass = "" }) => (
    <div className="stat-card">
        <div className="stat-card-header">
            <span className="stat-card-label">{label}</span>
            <div className={`stat-card-icon ${iconClass}`}>
                {icon}
            </div>
        </div>
        <div className="stat-card-content">
            <span className={`stat-card-value ${valueClass}`}>{value}</span>
        </div>
    </div>
);

export default StatsGrid;

